import { useFetchCallback } from '@services/services';
import { useIntegrationsActions } from '@store/actions/integrations';
import { Integration } from '@utils/constants';
import toast from 'react-hot-toast';

export const useRemoveIntegration = () => {
  const { call, isFetching } = useFetchCallback('delete', '/v1/integrations');
  const { removeIntegration: deleteIntegration } = useIntegrationsActions();

  const removeIntegration = async (integration: Integration, notify = true) => {
    try {
      await call({ path: integration.id });

      deleteIntegration(integration);

      if (notify) {
        toast.success('Servicio eliminado');
      }
    } catch (error) {
      toast.error('Error al eliminar el servicio');
    }
  };

  return {
    removeIntegration,
    isFetching,
  };
};
